/*
 Copyright 2023 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

import { EntityState, EntityStore, Store, StoreConfig } from '@datorama/akita';
import { Unit } from 'src/app/generated/blueprint.api';
import { Injectable } from '@angular/core';

export interface UnitState extends EntityState<Unit> {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'units' })
export class UnitStore extends EntityStore<UnitState> {
  constructor() {
    super();
  }
}
